document.addEventListener('DOMContentLoaded', () => {
    // Wait for GiftHeroAPI to be available
    let elapsed = 0;
    const intervalTime = 10;
    const maxTime = 10000;

    const intervalId = setInterval(() => {
        elapsed += intervalTime;

        if (window.GiftHeroAPI) {
            clearInterval(intervalId);
            initGiftHeroAddToCart();
        } else if (elapsed >= maxTime) {
            clearInterval(intervalId);
            console.warn('GiftHeroAPI not found after 10 seconds.');
        }
    }, intervalTime);

    // Handle amount selection styling
    const amountButtons = document.querySelectorAll('.amount-option');
    const hiddenInput = document.getElementById('gift-card-amount');

    amountButtons.forEach((button) => {
        button.addEventListener('click', () => {
            hiddenInput.value = button.getAttribute('data-value');
            amountButtons.forEach((btn) => btn.classList.remove('selected'));
            button.classList.add('selected');
        });
    });

    // Delivery date toggle logic
    const radioButtons = document.querySelectorAll('input[name="delivery"]');
    const datePickerContainer = document.getElementById('date-picker-container');
    const giftDeliveryInput = document.getElementById('delivery-date');
    const syncDeliveryMode = (mode, openPicker) => {
        const scheduled = mode === 'specific_date';
        datePickerContainer.style.display = scheduled ? 'block' : 'none';
        datePickerContainer.setAttribute('aria-hidden', String(!scheduled));
        giftDeliveryInput.setAttribute('aria-required', String(scheduled));
        const picker = giftDeliveryInput._flatpickr;
        if (scheduled) {
            if (openPicker) {
                giftDeliveryInput.focus();
                picker?.open();
            }
            return;
        }
        picker?.clear();
        picker?.close();
        giftDeliveryInput.value = '';
        if (picker?.mobileInput) picker.mobileInput.value = '';
        giftDeliveryInput.classList.remove('error-card');
        const selected = document.querySelector('.selected-date');
        const placeholder = document.querySelector('.placeholder-text');
        if (selected) {
            selected.textContent = '';
            selected.style.display = 'none';
        }
        if (placeholder) placeholder.style.display = 'inline';
        const calendarOverlay = document.getElementById('calendar-overlay');
        if (calendarOverlay) calendarOverlay.style.display = 'none';
    };
    radioButtons.forEach((item) => {
        item.addEventListener('change', (e) => {
            syncDeliveryMode(e.target.value, true);
        });
    });
    syncDeliveryMode(document.querySelector('input[name="delivery"]:checked')?.value, false);
    const giftRoot = document.querySelector('.container-gc');
    const messageField = document.getElementById('message');
    const messageCount = document.getElementById('gift-message-count');
    if (messageField && messageCount) {
        messageField.addEventListener('input', () => {
            messageCount.textContent = messageField.value.length
                ? messageCount.dataset.countLabel.replace('__COUNT__', messageField.value.length)
                : messageCount.dataset.emptyLabel;
        });
    }

    if (giftRoot) {
        const syncPresentation = () => {
            giftRoot.querySelectorAll('[data-gift-field]').forEach((field) => {
                const invalid = field.classList.contains('error-card');
                const errorId = field.dataset.errorId;
                const error = errorId && document.getElementById(errorId);
                field.setAttribute('aria-invalid', String(invalid));
                if (invalid && errorId) {
                    field.setAttribute('aria-describedby', errorId);
                } else {
                    field.removeAttribute('aria-describedby');
                }
                if (error) error.hidden = !invalid;
            });
            giftRoot.querySelectorAll('.amount-option').forEach((button) => {
                button.setAttribute('aria-pressed', String(button.classList.contains('active') || button.classList.contains('selected')));
            });
        };
        const presentationObserver = new MutationObserver(syncPresentation);
        presentationObserver.observe(giftRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        syncPresentation();
    }

});

const deliveryInput = document.querySelector("#delivery-date");
const selectedDateText = document.querySelector(".selected-date");
const placeholderText = document.querySelector(".placeholder-text");
const overlay = document.getElementById("calendar-overlay");
if (deliveryInput) {
    flatpickr(deliveryInput, {
        disableMobile: true, // Keep the calendar and overlay lifecycle consistent on phones.
        minDate: "today", // Disable past dates
        dateFormat: "Y-m-d", // Matches Shopify format
         onOpen: function () {
            overlay.style.display = "block";
        },
        onClose: function () {
            overlay.style.display = "none";
        },
        onChange: function (selectedDates, dateStr, instance) {
            if (dateStr) {
                const formatted = new Date(dateStr + 'T12:00:00').toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                });
                placeholderText.style.display = "none";
                selectedDateText.textContent = formatted;
                selectedDateText.style.display = "inline";
            } else {
                placeholderText.style.display = "inline";
                selectedDateText.style.display = "none";
            }
        },
    });

    overlay?.addEventListener('click', () => {
        deliveryInput._flatpickr?.close();
    });

}

function initGiftHeroAddToCart() {
    const [{ name, values }] = GiftHeroAPI.getOptions();
    const amountGrid = document.getElementById('product-amount-options');
    const hiddenInput = document.getElementById('gift-card-amount');

    amountGrid.innerHTML = '';

    values.forEach((value) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'amount-option';
        btn.textContent = value.name;
        btn.dataset.variantId = value.id;
        btn.dataset.value = value.name;

        btn.addEventListener('click', () => {
            GiftHeroAPI.setVariant(value.id);
            hiddenInput.value = value.name;

            document.querySelectorAll('.amount-option').forEach((button) => {
                button.classList.toggle('active', button === btn);
            });
        });

        amountGrid.appendChild(btn);
    });

    // Auto-select the first variant
    amountGrid.querySelector('button')?.click();

    const addToCartBtn = document.querySelector('.add-to-cart-btn');

    function addLoading() {
        addToCartBtn.style.pointerEvents = 'none';
        const btnText = addToCartBtn.querySelector('.btn-text');
        const btnLoader = addToCartBtn.querySelector('.btn-loader');
        addToCartBtn.style.padding = '4px 30px';
        btnText.style.display = 'none';
        btnLoader.style.display = 'inline-block';
    }

    function removeLoading() {
        addToCartBtn.style.pointerEvents = 'auto';
        const btnText = addToCartBtn.querySelector('.btn-text');
        const btnLoader = addToCartBtn.querySelector('.btn-loader');
        addToCartBtn.style.padding = '12px 30px';
        btnText.style.display = 'inline-block';
        btnLoader.style.display = 'none';
    }

    addToCartBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        addLoading();

        const message = document.getElementById('message')?.value?.trim();
        const fromEmail = document.getElementById('from_email')?.value?.trim();
        const toEmail = document.getElementById('to_email')?.value?.trim();
        const toName = document.getElementById('to_name')?.value?.trim();
        const selectedAmountBtn = document.querySelector('.amount-option.active');
        const selectedVariantId = selectedAmountBtn?.getAttribute('data-variant-id');
        const deliveryDateStr = document.getElementById('delivery-date')?.value;
        const deliveryOption = document.querySelector('input[name="delivery"]:checked')?.value;
        const image = GiftHeroAPI.getImages?.()[0];

        // Remove existing error styles
        document.querySelectorAll('.error-card').forEach((el) => {
            el.classList.remove('error-card');
        });

        const errors = [];
        const setError = (element, message) => {
            element.classList.add('error-card');
            if (!errors.includes(element)) {
                errors.push(element);
            }
        };

        if (!selectedVariantId) {
            setError(document.querySelector('.amount-grid'), 'Please select a gift card amount.');
        }

        if (!fromEmail || !validateEmail(fromEmail)) {
            setError(document.getElementById('from_email'), 'Please enter a valid sender email.');
        }

        if (!toName) {
            setError(document.getElementById('to_name'), "Please enter the recipient's name.");
        }

        if (!toEmail || !validateEmail(toEmail)) {
            setError(document.getElementById('to_email'), 'Please enter a valid recipient email.');
        }

        if (deliveryOption === 'specific_date' && !deliveryDateStr) {
            setError(document.getElementById('delivery-date'), 'Please select a delivery date.');
        }
        // Focus the first error field
        if (errors.length > 0) {
            removeLoading();
            errors[0].focus?.();
            return;
        }

        const deliveryDate = deliveryDateStr ? new Date(deliveryDateStr) : new Date();
        const fullMessage = message ? `Dear ${toName}\n\n${message}` : ' ';

        // Set data
        GiftHeroAPI.setCardData({
            deliveryDate,
            email: toEmail,
            from: fromEmail,
            image,
            message: fullMessage,
            variantId: selectedVariantId,
        });
        // console.log({ deliveryDate, email: toEmail,  from: fromEmail, image, message: fullMessage,variantId: selectedVariantId,});
        try {
            const isValid = GiftHeroAPI.validate?.();
            if (!isValid) {
                const validationErrors = GiftHeroAPI.getValidationErrors?.();
                if (Array.isArray(validationErrors)) {
                    validationErrors.forEach((error) => {
                        const field = error.field;
                        const input = document.getElementById(field);
                        if (input) {
                            input.classList.add('error-card');
                        }
                    });
                }
                removeLoading();
                return;
            }

            const response = await GiftHeroAPI.addToCart();
            removeLoading();
            if (response?.status === 422) {
                console.error('Cart error:', response.data.description || 'Unknown error');
                alert('Unable to add gift card: ' + (response.data.description || 'Unknown error'));
                window.reportToWorkManager?.(new Error('Gift card add failed'), { provider: 'shopify-ajax-cart', operation: 'cart_add', stage: 'gift_card', kind: 'rejected', classificationStatus: 'rejected', httpStatus: 422, errors: [{ code: '422', message: 'Gift card was rejected' }] });
            } else {
                window.location.href = '/cart';
            }
        } catch (error) {
            removeLoading();
            console.error('Unexpected error adding to cart:', error);
            alert('Something went wrong. Please try again.');
            window.reportToWorkManager?.(new Error('Gift card add failed'), window.reportToWorkManager.cartContext(error, 'cart_add', 'gift_card'));
        }
    });
}

function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}